(() => {
  /* Sprite sheets (Content → Files) are listed by the section: window.GBAG */
  const SHEETS_L = window.GBAG.sheetsL, SHEETS_S = window.GBAG.sheetsS;
  const NF = 61;
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const small = innerWidth * Math.min(devicePixelRatio || 1, 2) <= 900;
  const A = small ? { urls: SHEETS_S, cols: 4, rows: 4, fw: 800, fh: 450 } : { urls: SHEETS_L, cols: 3, rows: 3, fw: 1280, fh: 720 };
  const per = A.cols * A.rows;

  const hero = document.getElementById("hero"), stage = document.getElementById("stage");
  const canvas = document.getElementById("film"), ctx = canvas.getContext("2d");
  const caps = [...document.querySelectorAll(".cap")].map(el => ({ el, a: +el.dataset.in, b: +el.dataset.out }));
  const bar = document.getElementById("bar"), dock = document.getElementById("dock"), buy = document.getElementById("buy");
  const cue = document.getElementById("cue"), railFill = document.getElementById("railFill");
  const loader = document.getElementById("loader"), loadBar = document.getElementById("loadBar");

  /* ---- load sheets ---- */
  const sheets = new Array(A.urls.length), ok = new Array(A.urls.length).fill(false);
  let loaded = 0, started = false, needDraw = true;
  function loadSheet(k) {
    return new Promise(res => {
      const im = new Image(); im.decoding = "async";
      im.onload = () => { sheets[k] = im; ok[k] = true; loaded++; loadBar.style.transform = `scaleX(${loaded / A.urls.length})`; needDraw = true; res(); };
      im.onerror = () => res();
      im.src = A.urls[k];
    });
  }
  async function loadAll() {
    let k = 0;
    const worker = async () => { while (k < A.urls.length) await loadSheet(k++); };
    await Promise.all([worker(), worker(), worker()]);
    ready();
  }
  function ready() { if (started) return; started = true; loader.classList.add("done"); needDraw = true; }
  const frameOK = i => ok[Math.floor(i / per)];
  const nearest = i => { for (let d = 0; d < NF; d++) { if (i - d >= 0 && frameOK(i - d)) return i - d; if (i + d < NF && frameOK(i + d)) return i + d; } return -1; };

  /* ---- layout + draw ---- */
  let W = 0, H = 0, dpr = 1, portrait = false;
  function layout() {
    dpr = Math.min(devicePixelRatio || 1, 2);
    W = stage.clientWidth; H = stage.clientHeight; portrait = W / H < 0.9;
    canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
    stage.classList.toggle("portrait", portrait);
    if (portrait) {
      const bandH = (W / 0.68) * (9 / 16), cy = H * 0.40;
      canvas.style.setProperty("--t", `${Math.max(0, cy - bandH / 2)}px`);
      canvas.style.setProperty("--b", `${Math.min(H, cy + bandH / 2)}px`);
    }
    needDraw = true;
  }
  function paint(i, alpha) {
    const s = Math.floor(i / per), j = i % per, sheet = sheets[s];
    const sx = (j % A.cols) * A.fw, sy = Math.floor(j / A.cols) * A.fh;
    const sc = portrait ? W / (A.fw * 0.68) : Math.max(W / A.fw, H / A.fh);
    const dw = A.fw * sc * dpr, dh = A.fh * sc * dpr;
    const dx = (canvas.width - dw) / 2, dy = portrait ? H * 0.40 * dpr - dh / 2 : (canvas.height - dh) / 2;
    ctx.globalAlpha = alpha; ctx.drawImage(sheet, sx, sy, A.fw, A.fh, dx, dy, dw, dh);
  }
  function draw(f) {
    const i0 = Math.min(NF - 1, Math.floor(f)), t = f - i0;
    const a = nearest(i0); if (a < 0) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    paint(a, 1);
    if (t > 0.02 && i0 < NF - 1) { const b = nearest(i0 + 1); if (b >= 0 && b !== a) paint(b, t); }
    ctx.globalAlpha = 1;
  }

  /* ---- scroll progress ---- */
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  let target = 0, cur = 0, last = performance.now(), lastDrawn = -1, heroVisible = true;
  function readScroll() {
    const r = hero.getBoundingClientRect();
    target = clamp(-r.top / (r.height - innerHeight));
    bar.classList.toggle("on-paper", r.bottom < 64);
    const br = buy.getBoundingClientRect();
    dock.classList.toggle("show", target > 0.8 && br.top > innerHeight * 0.55 && r.top < innerHeight);
    heroVisible = r.bottom > -50 && r.top < innerHeight + 50;
  }
  function tick(now) {
    try { step(now); } catch (e) { console.error("render loop", e); }
    requestAnimationFrame(tick);
  }
  function step(now) {
    const dt = Math.min(0.05, (now - last) / 1000); last = now;
    if (heroVisible || cur !== target) {
      cur = reduce ? target : cur + (target - cur) * (1 - Math.exp(-dt * 10));
      if (Math.abs(target - cur) < 0.0002) cur = target;
      const f = cur * (NF - 1);
      if (needDraw || Math.abs(f - lastDrawn) > 0.001) { draw(f); lastDrawn = f; needDraw = false; }
      for (const c of caps) {
        const fade = 0.045;
        const o = (c.a <= 0 ? 1 : clamp((cur - c.a) / fade)) * clamp((c.b - cur) / fade);
        c.el.style.opacity = o.toFixed(3);
        c.el.style.transform = reduce ? "none" : `translateY(${((1 - o) * 16).toFixed(1)}px)`;
      }
      cue.style.opacity = clamp(1 - cur / 0.05);
      railFill.style.transform = `scaleY(${cur.toFixed(4)})`;
    }
  }

  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } }), { threshold: 0.15 });
  document.querySelectorAll(".rv").forEach((el, i) => { el.style.transitionDelay = `${(i % 3) * 0.08}s`; io.observe(el); });

  addEventListener("scroll", readScroll, { passive: true });
  addEventListener("resize", () => { layout(); readScroll(); });
  layout(); readScroll(); cur = target;
  loadAll(); requestAnimationFrame(tick);
  setTimeout(ready, 10000);
})();
